/* eslint-disable react/prop-types */
import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import SoftButton from "components/SoftButton";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 400,
  bgcolor: "background.paper",
  border: "none",
  outline: "none",
  boxShadow: 24,
  borderRadius: 1,
  p: 1,
};

export default function ModalCommon({ children, content, open, setOpen }) {
  const handleClose = () => setOpen(false);

  const navigation = useNavigate();

  return (
    <div>
      {open ? (
        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            {content}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
                mt: 2,
              }}
            >
              <SoftButton onClick={handleClose} color="dark">
                Đồng ý
              </SoftButton>
              <SoftButton
                onClick={() => {
                  handleClose();
                  navigation("/");
                }}
                color="secondary"
              >
                Đóng
              </SoftButton>
            </Box>
          </Box>
        </Modal>
      ) : (
        children
      )}
    </div>
  );
}
